import {
	SupportedOperation,
	OperationMetadata,
} from '@amzn/snow-data-service-typescript-client';


export enum OperationStatus {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
    DEPRECATED = 'DEPRECATED',
}

export enum IntegrationType {
    CORAL = 'Coral',
    APIGATEWAY = 'ApiGateWay',
}

export enum Encoding {
    UTF_8 = 'UTF_8',
    BASE_64 = 'BASE_64',
    BASE_32 = 'BASE_32',
}

export enum Protocol {
    CORAL_RPC_V0 = 'CORAL_RPC_V0',
    CORAL_RPC_V1 = 'CORAL_RPC_V1',
    RPC_V0 = 'RPC_V0',
}

export interface CombinedOperation
    extends Partial<OperationMetadata>,
        Partial<SupportedOperation> {}
